// removed by extract-text-webpack-plugin
module.exports = {"page":"_1_9PjQVc- _30W7J4cYZ gkmejKHip NYy_UUBwl FoW7vlZMf _1HeoWRlgs","centered":"_1tQa9e_E6 _3EiT4eWlg _2Kz2o9zH0 _1FoUCLbbD _2l0xl0HVf _2nov6tC6P"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/home-page/home-page.css
 ** module id = 2191
 ** module chunks = 0
 **/